module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0021.jpg?v=48da4388";